import React from 'react';

const TextBlockWidget = ({ config = {} }) => {
  const text = config.text || 'Add your text here...';
  const variant = config.variant || 'paragraph';
  const align = config.align || 'left';
  const textColor = config.textColor || '#374151';
  const bgColor = config.bgColor || '#ffffff';

  const variantStyles = {
    h1: 'text-2xl font-bold',
    h2: 'text-xl font-semibold',
    h3: 'text-lg font-semibold',
    paragraph: 'text-sm leading-relaxed',
    caption: 'text-xs text-gray-500'
  };

  return (
    <div className={`h-full flex items-center p-4 ${align === 'center' ? 'justify-center text-center' : align === 'right' ? 'justify-end text-right' : 'justify-start text-left'}`}
      style={{ backgroundColor: bgColor }}>
      <p className={variantStyles[variant] || variantStyles.paragraph} style={{ color: textColor }}>
        {text}
      </p>
    </div>
  );
};

export default TextBlockWidget;
